import { render, staticRenderFns } from "./MainExperts.vue?vue&type=template&id=18c7b51f&scoped=true&"
import script from "./MainExperts.vue?vue&type=script&lang=js&"
export * from "./MainExperts.vue?vue&type=script&lang=js&"
import style0 from "./MainExperts.vue?vue&type=style&index=0&id=18c7b51f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7b51f",
  null
  
)

export default component.exports